import { components } from './DnDNew/components/DnDItems/DnDComponents';
import { v4 as uuid } from 'uuid';
import { mergeObjects } from '../../helper/Converters';
const remove = (list, index) => {
  list.splice(index, 1);
  return list;
};
const reorder = (list, startIndex, endIndex) => {
  const [removed] = list.splice(startIndex, 1);
  list.splice(endIndex, 0, removed);
  return list;
};
const copy = (source, destination, droppableSource, droppableDestination, newItemId) => {
  const item = source && source[droppableSource.index];
  const componentType = item?.type;
  const componentName = item?.name;
  if (!componentType || !componentName || !components[componentType]) return null;

  destination.splice(droppableDestination.index, 0, { ...item, id: newItemId });
  return destination;
};
const duplicatePage = (source, index) => {
  const item = source && source[index];
  const newItem = structuredClone(item);
  const sections = newItem?.sections;
  sections.forEach(section => {
    section.id = uuid();
    const themeData = section?.themeData;
    themeData.forEach(componentData => {
      componentData.id = uuid();
    });
  });
  source.splice(index + 1, 0, { ...newItem, id: uuid() });
  return source;
};

const duplicateSection = (source, index) => {
  const item = source && source[index];
  const newItem = structuredClone(item);
  const themeData = newItem?.themeData?.map(componentData => {
    return { ...componentData, id: uuid() };
  });
  themeData.forEach(componentData => {
    componentData.id = uuid();
  });
  source.splice(index + 1, 0, { ...newItem, id: uuid() });
  return source;
};
const duplicateThemeData = (source, index) => {
  const item = source && source[index];
  const newItem = structuredClone(item);
  const componentType = newItem?.type;
  const componentName = newItem?.name;
  if (!componentType || !componentName || !components[componentType]) return null;

  source.splice(index + 1, 0, { ...newItem, id: uuid() });
  return source;
};
const override = (item, destination, isReset, indexToReplace) => {
  const componentType = item?.type;
  const componentName = item?.name;
  if (!componentType || !componentName || !components[componentType]) return null;

  if (isReset || indexToReplace === -1) {
    destination.splice(0, 1, { ...item, id: uuid() });
    return destination;
  }

  if (indexToReplace > -1 && destination[indexToReplace]) {
    destination[indexToReplace].data = mergeObjects(item?.data, destination[indexToReplace]?.data);
    destination[indexToReplace].customization = mergeObjects(
      item?.customization,
      destination[indexToReplace]?.customization,
    );
    destination[indexToReplace].name = componentName;
    return destination;
  }

  return destination;
};

export { reorder, copy, override, duplicateThemeData, remove, duplicateSection, duplicatePage };
